import { render } from "./GlobalDialog.vue?vue&type=template&id=9eb242e0&scoped=true"
import script from "./GlobalDialog.vue?vue&type=script&lang=js"
export * from "./GlobalDialog.vue?vue&type=script&lang=js"

import "./GlobalDialog.vue?vue&type=style&index=0&id=9eb242e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb242e0"]])

export default __exports__